import { HiddenTarget } from '~/models/column-definition';
import { DataType } from '~/models/data-type';
import { CodeType, Modifiable } from '~/models/form-model';

/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.customisations.CustomisationConfig
 */
export interface CustomisationConfig {
	template: string;
	functionConfig: FunctionConfigBackend;
}

/**
 * This should correspond to the Java class  au.com.finsyn.acuritywebserver.core.customisations.FunctionConfig
 * Do not change properties and keep them synchronized with backend class.
 */
export interface FunctionConfigBackend {
	title: string | null;
	subHeading: string | null;
	fieldConfig?: FieldConfigBackend[];
	namePatternConfig?: FieldConfigBackend[];
	tableColumnConfig?: TableColumnConfig[];
	archiveCheckbox?: ArchiveCheckbox;
}

/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.customisations.tableconfig.TableColumnConfig
 */
export interface TableColumnConfig<T extends string = string> {
	name: T;
	label: string;
	dataType: DataType;
	hiddenFrom?: HiddenTarget[];
	codeAndDescriptionKey?: string;
}

/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.security.FieldConfig
 * Do not change properties and keep them synchronized with backend class.
 */
export interface FieldConfigBackend {
	codeAndDescriptionKey: string | null;
	codeType: CodeType | null;
	inputMask: string | null; // ie. !!
	label: string | null;
	defaultValue: string | null;
	modifiable: Modifiable | null;
	name: string;
	namePattern: string;
	required: boolean | null;
	visible: boolean;
	dataType: DataType | null;
}

export enum ArchiveCheckbox {
	HIDDEN = 'HIDDEN',
	UNCHECKED = 'UNCHECKED',
	CHECKED = 'CHECKED',
}

// export class CustomisationConfig implements CustomisationConfigBackend {
//
// 	public template: string;
// 	public functionConfig: FunctionConfigBackend;
//
// 	public constructor(backendData: CustomisationConfigBackend) {
// 		this.template = backendData.template;
// 		this.functionConfig = backendData.functionConfig;
// 	}
// }
